var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"city scroll-item"},_vm._l((_vm.city.potentials),function(potential){return _c('CityPotentialScreen',{key:potential.id,attrs:{"cityName":_vm.city.path,"potential":potential,"activePotential":_vm.activePotential,"potentials":_vm.city.potentials,"cityId":_vm.city.id},on:{"activePotentialChanged":_vm.changeActivePotential}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }